import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const upsertNotificationExpiry = (days) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/UpsertNotificationExpirySettings`,
    { expiryDays: days }
  );
};

export const GetNotificationsExpiry = (days) => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/GetNotificationExpirySettings`,
    days
  );
};

export const reportBreach = (acknowledgeReportBreachParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/ReportBreach`,
    acknowledgeReportBreachParameters
  );
};

export const getCustTypes = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/GetCustTypes`
  );
};

export const getBasicSiteInfo = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/GetBasicSiteInfo`
  );
};
export const getRateCardYears = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/MiscellaneousAdministration/GetRateCardYears`
  );
};

export default {
  reportBreach,
  getCustTypes,
  getBasicSiteInfo,
  getRateCardYears,
};
